import { type AvatarSize } from './constants/avatarSizes'
import { AvatarInitialsStyled } from './styles/AvatarInitialsStyled'
import { AvatarPhotoStyled } from './styles/AvatarPhotoStyled'
import { AvatarStyled, type AvatarViewingContext } from './styles/AvatarStyled'
import { getNameInitials } from './utils/getNameInitials'

export interface IAvatarProps {
  photoUrl?: string
  name?: string
  viewingContext?: AvatarViewingContext
  size?: AvatarSize
  shadow?: boolean
}

export const Avatar = ({
  photoUrl,
  name,
  viewingContext = 'others',
  size = 'small',
  shadow,
}: IAvatarProps) => {
  return (
    <AvatarStyled
      $size={size}
      $shadow={shadow}
      $viewingContext={viewingContext}
      role={name ? 'img' : undefined}
      aria-label={name}
    >
      <AvatarInitialsStyled aria-hidden='true' $size={size}>
        {getNameInitials(name)}
      </AvatarInitialsStyled>
      {photoUrl && (
        <AvatarPhotoStyled aria-hidden='true' $photoUrl={photoUrl} />
      )}
    </AvatarStyled>
  )
}

Avatar.displayName = 'Avatar'
